import { Card, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { TENANT_NAME } from '../../tenant/tenant-names';
import { AveliosButton } from '../common-layout/avelios-button';
import styles from './home.module.scss';

export const InfoCards: FC = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  return (
    <Row justify="space-evenly" gutter={[32, 32]}>
      <Col xs={{ span: 24 }} lg={{ span: 10 }}>
        <Card
          onClick={() => router.push('/facility-selection')}
          className={styles.infoCard}
          hoverable
          cover={
            <div className={styles.infoCardImage}>
              <Image alt="Termine" src="/appointment.jpeg" layout="fill" objectFit={'contain'} />
            </div>
          }
        >
          <Title className={styles.infoCardTitle}>
            {formatMessage({ id: 'home.appointment' })}
          </Title>
          <p>{formatMessage({ id: 'home.appointment.meta' }, { tenant: TENANT_NAME })}</p>
          <AveliosButton
            size={'large'}
            type={'primary'}
            block
            onClick={() => router.push('/facility-selection')}
          >
            {formatMessage({ id: 'home.create-appointment' })}
          </AveliosButton>
        </Card>
      </Col>

      {/*<Col xs={{ span: 24 }} lg={{ span: 8 }}>*/}
      {/*  <Card*/}
      {/*    className={styles.infoCard}*/}
      {/*    hoverable*/}
      {/*    cover={*/}
      {/*      <div className={styles.infoCardImage}>*/}
      {/*        <Image alt="Dokumente" src="/document.jpeg" layout="fill" />*/}
      {/*      </div>*/}
      {/*    }*/}
      {/*  >*/}
      {/*    <Title>{formatMessage({ id: "home.documents" })}</Title>*/}
      {/*    <p>{formatMessage({ id: "home.documents.meta" })}</p>*/}
      {/*    <Button*/}
      {/*      type={"ghost"}*/}
      {/*      block*/}
      {/*      onClick={() => router.push("/documents")}*/}
      {/*    >*/}
      {/*      {formatMessage({ id: "home.see-documents" })}*/}
      {/*    </Button>*/}
      {/*  </Card>*/}
      {/*</Col>*/}

      <Col xs={{ span: 24 }} lg={{ span: 10 }}>
        <Card
          className={styles.infoCard}
          hoverable
          onClick={() => router.push('/data-security')}
          cover={
            <div className={styles.infoCardImage}>
              <Image
                alt="data-security"
                src="/data-security.jpg"
                layout="fill"
                objectFit={'contain'}
              />
            </div>
          }
        >
          <Title className={styles.infoCardTitle}>
            {formatMessage({ id: 'home.data-security' })}
          </Title>
          <p>{formatMessage({ id: 'home.data-security.meta' })}</p>
          <AveliosButton
            size={'large'}
            type={'ghost'}
            block
            onClick={() => router.push('/data-security')}
          >
            {formatMessage({ id: 'home.data-security.more' })}
          </AveliosButton>
        </Card>
      </Col>
    </Row>
  );
};
